module.exports = __webpack_public_path__ + "static/media/laborImage.c3ede370.png";